import {
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
  } from "@mui/material";
  import _ from "lodash";
  import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
import { useStyle } from "../style";
import * as XLSX from "xlsx"
  const ModalTable = ({tableHeadData , tableBodyData,setOpen,data}) => {
    console.log(data,"view data")
 const classes = useStyle()
 const location = useLocation()
 const currentPath = location.pathname;
 const exportToExcel = () => {
  // Define the headers and corresponding keys for the export
  const exportColumns = [
    { key: "sNo", label: "S No" },
    { key: "barcode", label: "Barcode" },
    { key: "proName", label: "Product Name" },
    { key: "category_name", label: "Category Name" },
    { key: "subcategory_name", label: "Subcategory Name" },
    { key: "Mrp", label: "MRP" },
  ];

  // Map table data to include only specified columns and their values
  const exportData = tableBodyData.map((val, index) => ({
    sNo: index + 1,
    barcode: val.name || "",
    proName: val.pro_name || "",
    category_name: val.category_name || "",
    subcategory_name: val.subcategory_name || "",
    Mrp: Number(val.Mrp) || 0, // Ensure numeric formatting
  }));

  // Calculate total MRP
  const totalAmount = exportData.reduce((sum, row) => sum + row.Mrp, 0);

  // Add a "Total Amount" row at the end of the export data
  const totalRow = {
    sNo: "",
    barcode: "",
    proName: "",
    category_name: "",
    subcategory_name: "Total Amount",
    Mrp: totalAmount, // Total Amount in numeric format
  };

  exportData.push(totalRow);

  // Transform data to match header labels for export
  const dataWithHeaders = [
    exportColumns.reduce((acc, col) => ({ ...acc, [col.label]: col.label }), {}),
    ...exportData.map((row) =>
      exportColumns.reduce((acc, col) => ({ ...acc, [col.label]: row[col.key] }), {})
    ),
  ];

  // Create a worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(dataWithHeaders, { skipHeader: true });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Closing Report");

  // Save the file
  XLSX.writeFile(workbook, "closingreport_data.xlsx");
};

//  const exportToExcel = () => {
//   // Define the headers and corresponding keys for the export
//   const exportColumns = [
//     { key: "sNo", label: "S No" },
//     // { key: "date", label: "Date" }, // Add if applicable, adjust as necessary
//     { key: "barcode", label: "Barcode" },
//     { key: "proName", label: "Product Name" },
//     { key: "category_name", label: "Category Name" },
//     { key: "subcategory_name", label: "Subcategory Name" },
//     { key: "Mrp", label: "MRP" },
//   ];

//   // Map table data to include only specified columns and their values
//   const exportData = tableBodyData.map((val, index) => ({
//     sNo: index + 1,
//     // date: val.date || "", // Optional, ensure to use a valid key from tableBodyData
//     barcode: val.name || "",
//     proName: val.name || val.pro_name || "",
//     category_name: val.category_name || "",
//     subcategory_name: val.subcategory_name || "",
//     Mrp: val.Mrp || "",
//   }));

//   // Transform data to match header labels
//   const dataWithHeaders = [
//     exportColumns.reduce((acc, col) => ({ ...acc, [col.label]: col.label }), {}),
//     ...exportData.map((row) =>
//       exportColumns.reduce((acc, col) => ({ ...acc, [col.label]: row[col.key] }), {})
//     ),
//   ];

//   // Create a worksheet and workbook
//   const worksheet = XLSX.utils.json_to_sheet(dataWithHeaders, { skipHeader: true });
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Closing Report");

//   // Save the file
//   XLSX.writeFile(workbook, "closingreport_data.xlsx");
// };
console.log(tableBodyData,"tableBodyData");


    return ( 
      <Grid sx={{ backgroundColor: "#fff",padding:"10px",maxHeight:"500px" ,overflowY:"auto"}}>
        <div className="flex justify-between">
          {data && 
          <Grid className="my-1">
               <Button
                    variant="contained"
                    color="primary"
                    onClick={exportToExcel}
                    sx={{ alignSelf: "flex-start" }}
                >
                    Export to Excel
                </Button>
            {/* <Typography sx={{marginBlock:.5}}>Bill No : <strong>{data.documentNo}</strong></Typography>
            <Typography>Bill Date : <strong>{data.documentDate}</strong></Typography> */}
          </Grid>
          }
          {currentPath == "/reports/outletSalesReport" && data &&
          <>
            <div className="flex my-1" style={{flexDirection:"column"}}>
            <Typography >Sales Man : <strong>{data.sales_man_name}</strong> - <strong>{data.sales_man_code}</strong> </Typography>
             <Typography>Payment Mode : <strong>{data.mode}</strong></Typography>
          </div>
          </>
          }
            
          <IconButton size="small" sx={{marginBlockEnd:2,}} onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
     
        </div>
        <TableContainer className={classes.tblRoot} sx={{ maxHeight: "400px", overflowY: "auto" }}>
          <Table stickyHeader className={classes.table}>
            <TableHead   className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
              <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
                {tableHeadData.map((item) => (
                  <TableCell className={classes.tblCell} 
                  sx={{
              backgroundColor: "#A06EE1",
              color: "#fff",
              position: "sticky",
              top: 0,
              zIndex: 1, // Important to appear above body rows
            }}
                  key={item.id}>{item.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
            {tableBodyData.map((val) => (
              <>
                  <TableRow className={classes.tablrow}  key={val.id}>
                <TableCell sx={{borderLeft:"1px solid #ccc !important"}}>{val.sNo}</TableCell>
                <TableCell>{val.name || val.pro_name}</TableCell>
                <TableCell>{val.pro_name}</TableCell>
                <TableCell>{val.category_name}</TableCell>
                <TableCell>{val.subcategory_name}</TableCell>
                <TableCell>{val.Mrp}</TableCell>
                   
              </TableRow>
              </>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TableContainer 
  className={classes.tblRoot}
  sx={{ maxHeight: "400px", overflowY: "auto" }}
>
  <Table stickyHeader className={classes.table}>
    <TableHead>
      <TableRow>
        {tableHeadData.map((item) => (
          <TableCell className={classes.tblCell}
            key={item.id}
            sx={{
              backgroundColor: "#A06EE1",
              color: "#fff",
              position: "sticky",
              top: 0,
              zIndex: 1, // Important to appear above body rows
            }}
          >
            {item.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {tableBodyData.map((val) => (
        <TableRow key={val.id}>
          <TableCell>{val.sNo}</TableCell>
          <TableCell>{val.name || val.pro_name}</TableCell>
          <TableCell>{val.pro_name}</TableCell>
          <TableCell>{val.category_name}</TableCell>
          <TableCell>{val.subcategory_name}</TableCell>
          <TableCell>{val.Mrp}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer> */}

        {data &&
        <Grid className="flex justify-end">
 
        <Grid>

 <Typography sx={{textAlign:"end",padding:1}}>Total Amount : <strong>{Math.round(data.totalAmount)}</strong></Typography>
        </Grid>
        </Grid>
        }

      </Grid>
    );
  };
  
  export default ModalTable;